module.exports = __webpack_public_path__ + "static/media/x-icon.97855264.svg";